import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';

const SUCCESS_NOTIFICATION_DURATION = 2500;
const ERROR_NOTIFICATION_DURATION = 4000;

export const showProgressNotification = (
    id: string,
    title: string,
    message: string
): void => {
    notifications.show({
        'data-testid': `notification-${id}`,
        id,
        loading: true,
        title,
        message,
        autoClose: false,
        withCloseButton: false
    });
};

export const finishProgressNotification = (
    id: string,
    color: 'green' | 'red',
    title: string,
    message = '',
    autoClose = color === 'green'
        ? SUCCESS_NOTIFICATION_DURATION
        : ERROR_NOTIFICATION_DURATION
): void => {
    notifications.update({
        'data-testid': `notification-${id}`,
        id,
        loading: false,
        color,
        title,
        message,
        autoClose,
        withCloseButton: true
    });
};

type ConfirmDeleteModalParams = {
    title: React.ReactNode;
    children: React.ReactNode;
    confirmLabel: string;
    onConfirm: () => void;
};
export const openConfirmDeleteModal = ({
    title,
    children,
    confirmLabel,
    onConfirm
}: ConfirmDeleteModalParams) => {
    modals.openConfirmModal({
        title: <div className="text-lg break-all">{title}</div>,
        centered: true,
        children: <div className="text-sm break-all">{children}</div>,
        labels: { confirm: confirmLabel, cancel: 'Cancel' },
        confirmProps: { color: 'red' },
        cancelProps: { variant: 'outline', color: 'gray' },
        onConfirm
    });
};

export const openErrorModal = ({ message }: { message: string }) => {
    modals.open({
        title: <div className="text-red-6">Error</div>,
        centered: true,
        children: <div className="break-all text-sm">{message}</div>,
        size: 'xs'
    });
};
